// extracted by mini-css-extract-plugin
module.exports = {"noPlayersPlaceholder":"Placeholder_noPlayersPlaceholder__23Kvf"};